import { useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { NAV_LINKS, slug } from "../../lib/site";
import { GOLD_FILL, StarPulse } from "./kit";
import { useInvite } from "./InviteContext";

export default function MobileMenu({ onClose }) {
  const openInvite = useInvite();
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);
  return createPortal(
    <div
      className="fixed inset-0 z-[90] flex flex-col"
      style={{ background: "linear-gradient(180deg, rgba(4,6,16,0.98) 0%, rgba(0,0,0,0.98) 100%)", backdropFilter: "blur(14px)", animation: "msFadeIn 320ms ease forwards" }}
      data-testid="mobile-menu"
    >
      <div className="flex items-center justify-between px-5 pt-6">
        <Link to="/" onClick={onClose} className="flex items-center gap-3" aria-label="Maven Skies" data-testid="mobile-menu-home">
          <img src="/brand/maven-m.webp" alt="" width={26} height={34} className="block" />
          <span className="text-[10px] tracking-[0.36em] uppercase" style={{ color: "#c8bd9a", fontFamily: "Fraunces, serif" }}>Maven Skies</span>
        </Link>
        <button type="button" onClick={onClose} className="p-2 rounded-full transition hover:bg-white/[0.05]" style={{ color: "#e9d6a2" }} data-testid="mobile-menu-close" aria-label="Close menu">
          <X size={20} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto flex flex-col items-center justify-center gap-5 px-8 py-6">
        {NAV_LINKS.map((l) =>
          l.children ? (
            <div key={l.label} className="flex flex-col items-center gap-3">
              <span className="text-[10px] tracking-[0.36em] uppercase" style={{ color: "#bfa874" }}>{l.label}</span>
              {l.children.map((c) => (
                <Link key={c.label} to={c.href} onClick={onClose} data-testid={`mobile-nav-${slug(c.label)}`} className="text-[18px] transition-colors hover:text-white" style={{ color: "#e9d6a2", fontFamily: "Fraunces, serif", fontStyle: "italic" }}>
                  {c.label}
                </Link>
              ))}
            </div>
          ) : (
            <Link key={l.label} to={l.href} onClick={onClose} data-testid={`mobile-nav-${slug(l.label)}`} className="text-[22px] tracking-[-0.01em] transition-colors hover:text-white" style={{ color: "#f3ead2", fontFamily: "Fraunces, serif" }}>
              {l.label}
            </Link>
          )
        )}
        <div aria-hidden className="mt-4" style={{ height: 1, width: 60, background: "linear-gradient(90deg, transparent, #bfa874, transparent)" }} />
        <button
          type="button"
          onClick={() => { onClose(); openInvite(); }}
          data-testid="mobile-nav-request-invitation"
          className="relative inline-flex items-center px-7 py-3 rounded-full text-[10.5px] tracking-[0.32em] uppercase font-semibold overflow-hidden"
          style={GOLD_FILL}
        >
          <StarPulse />
          <span className="relative z-[2]">Request Invitation</span>
        </button>
      </div>
    </div>
  , document.body);
}
